export default "__VITE_ASSET__CZA$QcrT__"